{
  "validation": {
    "required": "Uppgiften är obligatorisk",
    "invalidDate": "Felaktigt datum, ange i formatet dd.mm.åååå",
    "tooSmallDate": "Datumet är för litet",
    "moveDateAfterEndDate": "Utflyttningsdatumet kan inte vara senare än avtalets slutdatum.",
    "tooBigDate": "Datumet är för stort",
    "invalidPostalCode": "Felaktigt postnummer",
    "invalidNumber": "Felaktigt nummer",
    "tooBig": "För stort värde",
    "tooSmall": "För litet värde",
    "invalidIban": "Felaktigt kontonummer",
    "invalidBic": "Felaktig BIC-kod",
    "invalidType": "Felaktigt värde",
    "invalidEmail": "Felaktig e-postadress",
    "invalidPhoneNumber": "Felaktigt telefonnummer",
    "invalidString": "Felaktigt värde",
    "invalidSsn": "Felaktigt personnummer",
    "invalidPin": "Felaktig kod",
    "invalidReturnPercentageSum": "Summan av returprocenttalen ska vara 100 %.",
    "invalidRooReturnPercentageSum": "Återbetalningsandelarna för bostadsrättsavgiften ska vara sammanlagt 100 % eller alla vara tomma.",
    "titleDescriptionOrFilesRequired": "Rubrik, beskrivning eller bifogad fil är obligatoriska uppgifter",
    "noResidentUser": "Boende har inget boendesidekonto. Kontot måste först skapas genom att registrera sig på boendesidan.",
    "terminatedAdultMissingResidentUser": "Den valda myndiga personen som ska sägas upp saknar inloggning till boendesidan. Personen kan inte sägas upp via boendesidan.",
    "noAdultLeft": "Det finns ingen myndig person kvar i bostaden som avtalet kan överföras till.",
    "otherContractPartyTermination": "Den andra avtalsparten kan endast sägas upp när hela avtalet sägs upp.",
    "too_small_date": "Datumet är för litet",
    "invalid_date": "Felaktigt datum",
    "too_big_date": "Datumet är för stort",
    "move_date_after_end_date": "Utflyttningsdatumet kan inte vara senare än avtalets slutdatum.",
    "invalid_postal_code": "Felaktigt postnummer",
    "invalid_number": "Felaktigt nummer",
    "invalid_iban": "Felaktigt kontonummer",
    "invalid_bic": "Felaktig BIC-kod",
    "invalid_email": "Felaktig e-postadress",
    "invalid_phone_number": "Felaktigt telefonnummer",
    "invalid_string": "Felaktigt värde",
    "invalid_ssn": "Felaktigt personnummer",
    "invalid_pin": "Felaktig kod",
    "invalid_return_percentage_sum": "Summan av returprocenttalen ska vara 100 %.",
    "invalid_roo_return_percentage_sum": "Återbetalningsandelarna för bostadsrättsavgiften ska vara sammanlagt 100 % eller alla vara tomma.",
    "title_description_or_files_required": "Rubrik, beskrivning eller bifogad fil är obligatoriska uppgifter",
    "no_resident_user": "Boende har inget boendesidekonto. Kontot måste först skapas genom att registrera sig på boendesidan.",
    "terminated_adult_missing_resident_user": "Den valda myndiga personen som ska sägas upp saknar inloggning till boendesidan. Personen kan inte sägas upp via boendesidan.",
    "no_adult_left": "Det finns ingen myndig person kvar i bostaden som avtalet kan överföras till.",
    "other_contract_party_termination": "Den andra avtalsparten kan endast sägas upp när hela avtalet sägs upp."
  },
  "other": {
    "noActiveContracts": "Du har för närvarande inget gällande avtal.",
    "errorFecthingContracts": "Det uppstod ett fel vid sökningen av avtal, försök logga in på nytt.",
    "internalError": "Det uppstod ett fel.",
    "internalErrorLogin": "Försök logga in på nytt.",
    "genericError": "Hoppsan, något gick fel. Försök igen senare.",
    "pageLoadTimedOut": "Ett fel uppstod när sidan laddades. Försök igen om en stund.",
    "pageOutOfOrder": "Boendesidorna är inte tillgängliga just nu. Var god och försök på nytt senare.",
    "staleClientRefreshRequired": "Sidan har uppdaterats. Ladda om sidan och försök säga upp avtalet på nytt.",
    "identificationRequired": "Att bekräfta åtgärden kräver stark autentisering. Autentisera dig på sidan Egna uppgifter och försök igen.",
    "pageNotFound": "Sidan kunde inte hittas",
    "defectNoticeSubmitError": "Ett fel uppstod när felanmälan skulle skickas. Om problemet kvarstår eller om felet är brådskande ska du kontakta kundservicen.",
    "defectNoticeAPIError": "En felanmälan kan inte göras för tillfället. Var god och försök på nytt senare.",
    "additionalNotification": "Vid brådskande fall kontakta kundtjänsten.",
    "backToLogin": "Till inloggningssidan",
    "registrationIsOutOfOrder": "Det är inte möjligt att registrera sig just nu. Var god och försök på nytt senare.",
    "noPhoneNumber": "Felanmälan är ur bruk",
    "noPhoneNumberText": "Lägg till ditt telefonnummer i din profil för att fortsätta med felanmälan.",
    "failedToOpenAttachment": "Det gick inte att öppna bilagan",
    "errorLoadingBuilding": "Fel vid hämtning av fastighetsinformation. Försök igen senare.",
    "incorrectRegistrationProvider": "Registreringen misslyckades, försök igen.",
    "unboundResidentUser": "Fel vid hämtning av avtal. Kontakta vår kundservice.",
    "eventId": "Felkod: {{id}}"
  },
  "auth": {
    "errorUserNotVerified": "Användarens e-postadress har inte bekräftats.",
    "invalidCredentials": "Felaktigt användarnamn eller lösenord"
  }
}
